import { render, staticRenderFns } from "./ArticleBody.vue?vue&type=template&id=134e543c&"
import script from "./ArticleBody.vue?vue&type=script&lang=ts&"
export * from "./ArticleBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports